<template>
  <div class="page">
    <c-source-form
      :columns="columns"
      :data="data"
      @submit="handleUpdate"
    />
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class EditOrder extends Vue {
  @Prop(String) resource;
  data = {}

  get columns() {
    return createColumns.call(this, { resource: this.resource });
  }

  async mounted() {
    this.data = await this.$request.get(`${this.resource}/${this.$route.params.id}`);
  }

  async handleUpdate(data) {
    const id = this.data.id;
    await this.$autoLoading(this.$request.put(`${this.resource}/${id}/update_remark`, data));
    this.$router.replace({ name: `${this.resource}.show`, params: { id } });
  }
}
</script>
